<template>
    <div v-loading="loading">
        <div v-show="viewPart === 'list'">
<!--            <div class="operation-btns">-->
<!--                <div>-->
<!--                    <span>&nbsp;</span>-->
<!--                </div>-->

<!--                <div>-->
<!--                    <el-button @click="goAdd" tkey="添加">{{i18n.tkey("lang_add")}}</el-button>-->
<!--                </div>-->
<!--            </div>-->

            <div class="data-list">
                <IslandList
                    v-if="viewPart === 'list'"
                    :list="dataList"
                    @clickEdit="goEdit"
                    @clickManage="goManage"
                />
            </div>
        </div>

        <div v-if="viewPart === 'edit'">
            <EditorTitle
                :showReturnBtn="true"
                :returnLabel="i18n.tkey('return')"
                :showOperationBtn="false"
                :titleLabel="i18n.tkey('lang_island_merchants')"
                @clickReturnBtn="clickReturnBtn"
            />

            <IslandShopEditor
                :islandObj="editObj"
            />

        </div>

        <el-dialog
            v-model="editDialogVisible"
            :title="i18n.tkey('lang_modify_information')"
            :width="'90%'"
            align-center
            destroy-on-close
            center
            :close-on-click-modal="false"
            :close-on-press-escape="false"
        >
            <AddOrEditIsland
                :editObj="editObj"
                :readOnlyTag="readOnlyTag"
                @save-complete="saveCallback"
            />
        </el-dialog>

    </div>
</template>

<script setup>

import {inject, getCurrentInstance, ref, toRef, onBeforeMount} from "vue";
import IslandList from "@/components/shopopee/island/islandList.vue";
import IslandShopEditor from "@/components/shopopee/island/islandShopEditor.vue";
import record14Api from "@/request/record14Api";
import myUtil from "@/util/util";
import EditorTitle from "@/components/shopopee/common/editorTitle.vue";
import AddOrEditIsland from "@/components/shopopee/island/addOrEditIsland.vue";

const props = defineProps(["companyObj"])
const emits = defineEmits(["goEdit", "goList"])

const i18n = inject("i18n")
const loading = ref(false)

const dataList = ref([])
const viewPart = ref("list")

const editDialogVisible = ref(false)
const editObj = ref(null)
const readOnlyTag = ref(false)

function getRecordList(){
    loading.value = true

    const request = record14Api.getIslandInfoList
    const params = request.getParams()

    params.companycode = props.companyObj.companycode

    request.send(params, (res) => {
        loading.value = false

        if (res.code == 200){
            dataList.value = res.detail
        }else{
            myUtil.alertError(res.msg)
        }
    })

}

function goEdit(obj){
    editObj.value = obj
    readOnlyTag.value = false
    editDialogVisible.value = true
    // emits("goEdit")
    // viewPart.value = "edit"
}

function clickReturnBtn(){
    editObj.value = null
    readOnlyTag.value = false
    emits("goList")
    viewPart.value = "list"
    getRecordList()
}

function goAdd(){
    // if (null != props.companyObj.additionalrecord11 && null != props.companyObj.additionalrecord11.addremark1){
    //     if (null != props.companyObj.additionalrecord11.addremark1.mallNum && props.companyObj.additionalrecord11.addremark1.mallNum > dataList.value.length){
    //         editObj.value = null
    //         readOnlyTag.value = false
    //         emits("goEdit")
    //         viewPart.value = "edit"
    //     }else{
    //         myUtil.alertWarning(i18n.tkey("lang_mall_limit_alert"))
    //     }
    // }else{
    //     myUtil.alertWarning(i18n.tkey("lang_mall_limit_alert"))
    // }
}

function saveCallback(){
    editDialogVisible.value = false
    editObj.value = null
    getRecordList()
}

function goManage(obj){
    viewPart.value = "edit"
    editObj.value = obj
    emits("goEdit")
}

onBeforeMount(() => {
    getRecordList()
})


</script>

<style scoped>
.operation-btns {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.data-list {
    margin-top: 25px;
}
</style>